import {RouteDefinition} from '../../../routes';
import {VirtualControlListScreen} from './VirtualControlListScreen';
import {VirtualControlEditScreen} from './VirtualControlEditScreen';

export const VirtualControlSettingsRoutes: RouteDefinition[] = [
    {
        name: 'Sanal Kontrol',
        routerLink: '/settings/virtual-control',
        component: VirtualControlListScreen,
    },
    {
        name: 'Sanal Kontrol Oluştur',
        routerLink: '/settings/virtual-control/edit',
        component: VirtualControlEditScreen,
    },
    {
        name: 'Sanal Kontrol Düzenle',
        routerLink: '/settings/virtual-control/edit/:id',
        component: VirtualControlEditScreen,
    },
];
